import {ExternalHosting, ToEmbedUrl} from './@types';

// Встраиваются только /embed/<id>: у /video/watch/<id> другой id
const EMBED_PATH = /^\/embed\/[\w-]+\/?$/;

const toDzenEmbed: ToEmbedUrl = (url) =>
    EMBED_PATH.test(url.pathname)
        ? url.href
        : null
;

export const dzenHosting: ExternalHosting = {
    hosts:   ['dzen.ru'],
    toEmbed: toDzenEmbed,
};
